import { useId, type SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement>;

export function CustomIconAppStoreChannel({ width = 48, height = 48, ...props }: Props) {
  const gradientId = useId();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800" width={width} height={height} {...props}>
      <defs>
        <linearGradient
          id={gradientId}
          x1="400.05"
          x2="400.05"
          y1="798.772"
          y2="-1.228"
          gradientTransform="matrix(1 0 0 -1 0 798.772)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#18bffb" />
          <stop offset="1" stopColor="#2072f3" />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${gradientId})`}
        d="M638.4 0H161.6C72.3 0 0 72.3 0 161.6v476.9C0 727.7 72.3 800 161.6 800h476.9c89.2 0 161.6-72.3 161.6-161.6V161.6C800 72.3 727.7 0 638.4 0z"
      />
      <path
        fill="#FFF"
        d="m396.6 183.8 16.2-28c10-17.5 32.3-23.4 49.8-13.4s23.4 32.3 13.4 49.8L319.9 462.4h112.9c36.6 0 57.1 43 41.2 72.8H143c-20.2 0-36.4-16.2-36.4-36.4s16.2-36.4 36.4-36.4h92.8l118.8-205.9-37.1-64.4c-10-17.5-4.1-39.6 13.4-49.8 17.5-10 39.6-4.1 49.8 13.4l15.9 28.1zM256.2 572.7l-35 60.7c-10 17.5-32.3 23.4-49.8 13.4S148 614.5 158 597l26-45c29.4-9.1 53.3-2.1 72.2 20.7zm301.4-110.1h94.7c20.2 0 36.4 16.2 36.4 36.4s-16.2 36.4-36.4 36.4h-52.6l35.5 61.6c10 17.5 4.1 39.6-13.4 49.8-17.5 10-39.6 4.1-49.8-13.4-59.8-103.7-104.7-181.3-134.5-233-30.5-52.6-8.7-105.4 12.8-123.3 23.9 41 59.6 102.9 107.3 185.5z"
      />
    </svg>
  );
}
